import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const baseService = createCrudService("clients", [], router);

export const clientsService = {
  ...baseService,
  listPaginated: (params) => api.getCall("/api/clients/paginated", params),
  getDocuments: (clientId) => api.getCall(`/api/clients/${clientId}/documents`),
  getNotes: (clientId) => api.getCall(`/api/clients/${clientId}/notes`),
  createNote: (clientId, note) => api.postCall(`/api/clients/${clientId}/notes`, { note }),
  getGoals: (clientId) => api.getCall(`/api/clients/${clientId}/goals`),
  addGoal: (clientId, question_text, question_type) => api.postCall(`/api/clients/${clientId}/goals`, { question_text, question_type }),
  updateGoal: (clientId, goalId, question_text, question_type) => api.putCall(`/api/clients/${clientId}/goals/${goalId}`, { question_text, question_type }),
  answerGoal: (clientId, goalId, answer, shiftId) => api.postCall(`/api/clients/${clientId}/goals/${goalId}/answer`, { answer, shiftId }),
  deleteGoal: (clientId, goalId) => api.deleteCall(`/api/clients/${clientId}/goals/${goalId}`),
  getMedications: (clientId) => api.getCall(`/api/clients/${clientId}/medications`),
  getMedicationsPaginated: (clientId, params) =>
    api.getCall(`/api/clients/${clientId}/medications/paginated`, params),
  addMedication: (clientId, data) => api.postCall(`/api/clients/${clientId}/medications`, data),
  updateMedication: (clientId, medId, data) => api.putCall(`/api/clients/${clientId}/medications/${medId}`, data),
  deleteMedication: (clientId, medId) => api.deleteCall(`/api/clients/${clientId}/medications/${medId}`),
  getMedicationHistory: (clientId, medId, params) => api.getCall(`/api/clients/${clientId}/medications/${medId}/history`, params),
  downloadMarPdf: (clientId, month, year) =>
    api.getBlobCall(`/api/mar/${clientId}/pdf`, { month, year }),
  uploadPhoto: (clientId, file) => {
    const formData = new FormData();
    formData.append("photo", file);
    return api.postFormDataCall(`/api/clients/${clientId}/photo`, formData);
  },
};
